<template>
  <v-container grid-list-md v-show="false">
    <v-layout row wrap id="printProposta">
      <v-flex xs12 sm4 lg3> 
        <img src="../Content/images/logo.png" alt="DentalPlus" width="110px">        
      </v-flex>          
      <v-flex xs12 sm4 lg4 justify-center>
        <p class="form-titulo" style="text-align: center; font-size: 17px;">RESUMO DA PROPOSTA Nº {{this.financialManagers.proposalNumber}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12>   
        <p class="tituloProposta" >Responsável Financeiro</p>
      </v-flex>
      <div class="containerProposta" v-if="this.financialManagers.firstName">   
        <p class="subtotal item containerProposta">Nome</p>
        <p class="itemValor">{{this.financialManagers.firstName}}</p>           
      </div>            
      <div class="containerProposta" v-if="this.financialManagers.cpf">   
        <p class="subtotal item containerProposta">CPF</p>
        <p class="itemValor">{{this.financialManagers.cpf}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.matricula">   
        <p class="subtotal item containerProposta">Matricula</p>
        <p class="itemValor">{{this.financialManagers.matricula}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.rg">   
        <p class="subtotal item containerProposta">RG</p>
        <p class="itemValor">{{this.financialManagers.rg}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.dateOfBirth">   
        <p class="subtotal item containerProposta">Nascimento</p>
        <p class="itemValor">{{formatDateBrz(this.financialManagers.dateOfBirth)}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.maritalStatus">   
        <p class="subtotal item containerProposta">Estado Civil</p>
        <p class="itemValor">{{this.financialManagers.maritalStatus}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.motherName">   
        <p class="subtotal item containerProposta">Nome da Mãe</p>
        <p class="itemValor">{{this.financialManagers.motherName}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.susNumber">   
        <p class="subtotal item containerProposta">CNS</p>
        <p class="itemValor">{{this.financialManagers.susNumber}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.cellPhone">   
        <p class="subtotal item containerProposta">Telefone</p>
        <p class="itemValor">{{this.financialManagers.cellPhone}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.email">   
        <p class="subtotal item containerProposta">E-mail</p>
        <p class="itemValor">{{this.financialManagers.email}}</p> 
      </div>
      <v-flex xs12 sm12 lg12>   
        <br>
        <p class="tituloProposta" >Endereço</p>
      </v-flex>
      <div class="containerProposta" v-if="this.financialManagers.cep">   
        <p class="subtotal item containerProposta">CEP</p>
        <p class="itemValor">{{this.financialManagers.cep}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.address">   
        <p class="subtotal item containerProposta">Logradouro</p>
        <p class="itemValor">{{this.financialManagers.address}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.addressNumber">   
        <p class="subtotal item containerProposta">Número</p>
        <p class="itemValor">{{this.financialManagers.addressNumber}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.addressComplement">   
        <p class="subtotal item containerProposta">Complemento</p>
        <p class="itemValor">{{this.financialManagers.addressComplement}}</p> 
      </div>
      <div class="containerProposta" v-if="bairro">   
        <p class="subtotal item containerProposta">Bairro</p>
        <p class="itemValor">{{bairro}}</p> 
      </div>
      <div class="containerProposta" v-if="cidade">   
        <p class="subtotal item containerProposta">Cidade</p>
        <p class="itemValor">{{cidade}}</p> 
      </div>
      <div class="containerProposta" v-if="estado">   
        <p class="subtotal item containerProposta">Estado</p>
        <p class="itemValor">{{estado}}</p> 
      </div>

      <v-flex xs12 sm12 lg12>   
        <br>
        <p class="tituloProposta">Titular</p>
      </v-flex>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Nome</p>
        <p class="itemValor">{{this.titular.firstName}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">CPF</p>
        <p class="itemValor">{{this.titular.cpf}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Nascimento</p>
        <p class="itemValor">{{formatDateBrz(this.titular.dateOfBirth)}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Estado Civil</p>
        <p class="itemValor">{{this.titular.maritalStatus}}</p> 
      </div>
      <div class="containerProposta">   
        <p class="subtotal item containerProposta">Nome da Mãe</p>
        <p class="itemValor">{{this.titular.motherName}}</p> 
      </div>

      <v-flex xs12 sm12 lg12 v-if="dependentes[0] && dependentes[0].firstName != ''">   
        <br>
        <p class="tituloProposta" >Dependentes</p>
      </v-flex>
      <div v-if="dependentes[0] && dependentes[0].firstName != ''">
        <div class="flex-container" v-for="dependente in dependentes" :key="`${dependente}`">           
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Nome</p>
            <p class="itemValor">{{dependente.firstName}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Parentesco</p>
            <p class="itemValor">{{dependente.parentage}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">CPF</p>
            <p class="itemValor">{{dependente.cpf}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Nascimento</p>
            <p class="itemValor">{{formatDateBrz(dependente.dateOfBirth)}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Estado Civil</p>
            <p class="itemValor">{{dependente.maritalStatus}}</p> 
          </div>
          <div class="containerProposta">   
            <p class="subtotal item containerProposta">Nome da Mãe</p>
            <p class="itemValor">{{dependente.motherName}}</p> 
          </div>
        </div>
      </div>

      <v-flex xs12 sm12 lg12>   
        <br>
        <p class="tituloProposta" >Informações do Plano</p>
      </v-flex>
      <div class="containerProposta" v-if="this.planoSelecionado[4]">   
        <p class="subtotal item containerProposta">Nome do Plano</p>
        <p class="itemValor">{{this.planoSelecionado[4]}}</p> 
      </div>
      <div class="containerProposta" v-if="this.planoSelecionado[0]">   
        <p class="subtotal item containerProposta">Valor do Plano</p>
        <p class="itemValor">R$ {{this.planoSelecionado[0]}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.responsibility">   
        <p class="subtotal item containerProposta">Valor Total</p>
        <p class="itemValor">R$ {{this.financialManagers.responsibility}}</p> 
      </div>
      <div class="containerProposta" v-if="this.financialManagers.vendedor">   
        <p class="subtotal item containerProposta">Vendedor</p>
        <p class="itemValor">{{this.financialManagers.vendedor}}</p> 
      </div>
      <footer>
        <img src="../Content/images/logo-ans.png" width="120px">
      </footer>
    </v-layout>
  </v-container>    
</template>

<script>
  import PH from 'print-html-element'
  import axios from 'axios'
  import { baseApiUrl, operadora } from '@/global'
  export default {
    data () {
      return {
        nomeUsuario: '',
        planoSelecionado: [],
        financialManagers: {
          contratanteTitular: true,
          confirmPassword: '',
          password: '',
          rg: '',
          rgEmitter: '',
          homePhone: '',
          cellPhone: '',
          cellPhone2: '',
          email: '',
          cep: '',
          address: '',
          addressType: '',
          addressTypeName: '',
          addressNumber: '',
          addressComplement: '',
          district: '',
          city: '',
          state: '',
          proposalNumber: 0,
          contractNumberS4: '',
          responsibility: '',
          cardNumber: '',
          cardValidity: '',
          cardFlag: '',
          cardDayExpiration: 15,
          dateSignatureContract: '',
          formOfPaymentId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: null,
          maritalStatus: null,
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: '',
          nsu: '',
          planoSelecionado: [],
          typeFm: 'FISICA',
          protocoloCancelamento: '',
          vendedor: '' 
        },
        bairro: '',
        estado: '',
        cidade: '',
        titular: {
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        },
        dependentes: [{
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        }]
      }
    },

    mounted : function() {
      if(localStorage.getItem('proposta') != null)
        this.financialManagers = JSON.parse(localStorage.getItem('proposta'))
      this.consultaCEP()
      this.carregaPlano()
      this.carregaBeneficiarios()
    },

    methods: {
      informacaoOperadora(atributo) {
        return operadora[atributo]
      },
      
      print() {
        var opts = {
          /* stylesheets:"<link rel='stylesheet' href='../Content/styles/minify/main.min.css'>", */
          pageTitle: "Proposta Nº "+this.financialManagers.proposalNumber
        }
        PH.printElement(document.getElementById('printProposta'),opts)
      },

      formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      consultaCEP() {
        if(/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
          axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep}).then(res => {     
            if(res.data != null) {
              this.financialManagers.address = res.data.Logradouro
              this.cidade = res.data.Municipio
              this.financialManagers.city = res.data.IdMunicipio
              this.estado = res.data.Uf
              this.financialManagers.state = res.data.IdUf
              this.bairro = res.data.Bairro
              this.financialManagers.district = res.data.IdBairro
              this.financialManagers.addressType = res.data.IdTipoLogradouro
              this.financialManagers.addressTypeName = res.data.TipoLogradouro
            } else {
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.financialManagers.address = ''
              this.cidade = ''
              this.financialManagers.city = ''
              this.estado = ''
              this.financialManagers.state = ''
              this.bairro = ''
              this.financialManagers.district = ''
              this.financialManagers.addressType = ''
            }             	
          })
        }           
      },

      async carregaBeneficiarios() {
        await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.financialManagers.id})
        .then(response => {
          if (response.data) {
            let titular = response.data.dependentes.filter(dependente => dependente.isHolder == true)
            this.titular = titular[0]
            this.dependentes = response.data.dependentes.filter(dependente => dependente.isHolder == false)
          }
        })
      },

      async carregaPlano(){
        axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManagers.plansId}`).then(res => {        
          if(res.data != null) {      
            this.planoSelecionado.push(res.data[0].value,res.data[0].area_atuacao,res.data[0].qualificacao,res.data[0].registro,res.data[0].name,res.data[0].cobertura,res.data[0].id,"",res.data[0].urlMinutaContrato,res.data[0].urlMinutaAditivo,res.data[0].urlManual,res.data[0].urlGuia,res.data[0].urlCobertura)   
          }            
        })
      }
    }
  }
</script>

<style>
  .tituloProposta {
    font-size:15px;
    font-weight:700;
    color:#797a7a;
    margin-bottom:5px;  
    text-align: center;  
    border: 1px solid; 
    border-color: #1DAFFC;
    border-radius: 10px;
    padding: 8px;
  }

  .flexProposta {
    display: flex;
    flex-wrap: nowrap;
  }

  .item {
    margin: 10px auto;
    font-size:18px;
    color: #1DAFFC;
  }

  .containerProposta {
    font-size:15px;
    min-width: auto;
    margin: 5px 20px 0 0;
  }

  .itemValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
  }

  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }

  .flex-container > div {
    min-width: auto;
    margin: 5px 20px auto auto;
    font-size:15px;
    color:#797a7a;
  }
</style>
